import { FC } from "react";

export const AnzenIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      className={className}
      width="1271"
      height="1090"
      viewBox="0 0 1271 1090"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M381.949 0C380.439 279.098 227.131 522.445 0 652.455L253.551 1089.43C632.254 872.219 887.541 465.814 889.05 0H381.949Z"
        fill="#A4D3FF"
      />
      <path
        d="M889.049 0C890.559 279.098 1043.87 522.445 1271 652.455L1017.45 1089.43C638.744 872.219 383.458 465.814 381.948 0H889.049Z"
        fill="#1E2FC5"
      />
      <path
        d="M381.948 0.22998C382.854 282.633 477.133 543.029 635.499 752.803C793.864 543.029 888.143 282.633 889.049 0.22998H381.948Z"
        fill="#2764FF"
      />
    </svg>
  );
};
